/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/

import { createAction, props } from '@ngrx/store';

import {
  GlobalPriceConfiguration,
  GLOBAL_PRICE_CONFIGURATION_CLIENT_TYPE,
} from '@models/global-price-configuration.model';
import { GlobalPriceConfigurationPriceType } from '@core/models';

export const loadGlobalConfig = createAction(
  '[Settings:GlobalConfig] Load global config',
  props<{ clientType: GLOBAL_PRICE_CONFIGURATION_CLIENT_TYPE }>()
);
export const loadGlobalConfigSuccess = createAction(
  '[Settings:GlobalConfig] Load global config success',
  props<{ globalConfigs: GlobalPriceConfiguration[] }>()
);
export const loadGlobalConfigFailure = createAction(
  '[Settings:GlobalConfig] Load global config failure',
  props<{ errorMessage: string }>()
);

export const batchUpdateGlobalConfigs = createAction(
  '[Settings:GlobalConfig] Batch Update global configs',
  props<{ configs: Partial<GlobalPriceConfiguration>[] }>()
);
export const batchUpdateGlobalConfigsSuccess = createAction(
  '[Settings:GlobalConfig] Batch Update global configs Success',
  props<{ configs: Partial<GlobalPriceConfiguration>[] }>()
);
export const batchUpdateGlobalConfigsFailure = createAction(
  '[Settings:GlobalConfig] Batch Update global configs Failure',
  props<{ errorMessage: string }>()
);

export const openUpdateModalDialog = createAction(
  '[Settings:GlobalConfig] Update update modal dialog',
  props<{ config: GlobalPriceConfiguration }>()
);

export const updateGlobalConfig = createAction(
  '[Settings:GlobalConfig] Update global config',
  props<{ config: Partial<GlobalPriceConfiguration> }>()
);
export const updateGlobalConfigSuccess = createAction(
  '[Settings:GlobalConfig] Update global config success',
  props<{ config: GlobalPriceConfiguration }>()
);
export const updateGlobalConfigFailure = createAction(
  '[Settings:GlobalConfig] Update global config Failure',
  props<{ errorMessage: string }>()
);

export const deleteGlobalConfigSuccess = createAction(
  '[Settings:GlobalConfig] Delete global config success',
  props<{ id: number }>()
);

export const addGlobalConfigSuccess = createAction(
  '[Settings:GlobalConfig] Add global config success',
  props<{ globalConfig: GlobalPriceConfiguration }>()
);

export const updatePriceType = createAction(
  '[Settings:GlobalConfig] Update Global Config Price Type',
  props<{ priceType: Partial<GlobalPriceConfigurationPriceType>; updatedBy: string }>()
);
export const updatePriceTypeSuccess = createAction(
  '[Settings:GlobalConfig] Update Global Config Price Type Success',
  props<{ priceType: GlobalPriceConfigurationPriceType; updatedBy: string }>()
);
export const updatePriceTypeFailure = createAction(
  '[Settings:GlobalConfig] Update Global Config Price Type Failure',
  props<{ errorMessage: string }>()
);

export const updateSelectedPriceTypes = createAction(
  '[Settings:GlobalConfig] Update Global Selected Price Types',
  props<{ priceTypes: Partial<GlobalPriceConfigurationPriceType[]>; updatedBy: string }>()
);
export const updateSelectedPriceTypesSucccess = createAction(
  '[Settings:GlobalConfig] Update Global Config Selected Price Types Success',
  props<{ priceTypes: GlobalPriceConfigurationPriceType[]; updatedBy: string }>()
);
export const updateSelectedPriceTypesFailure = createAction(
  '[Settings:GlobalConfig] Update Global Config Selected Price Types Failure',
  props<{ errorMessage: string }>()
);

export const saveChangesAfterCanActivateGuard = createAction(
  '[Settings:GlobalConfig] Save Changes After Can Acivate Guard'
);
